import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpService } from '../../../../services/http.service';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { USER_MGMT_CNST } from '../../../../constants/proj.cnst';
import { CommonModule } from '@angular/common';
import { SkeletonModule } from '../../../../modules/shared/components/skeleton/skeleton.module';
import { ImportsModule } from '../../../../modules/imports/imports';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { TablerIconComponent,provideTablerIcons } from 'angular-tabler-icons';
import { DropdownModule } from 'primeng/dropdown';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-role-valid-scope',
  templateUrl: './role-valid-scope.component.html',
  styleUrls: ['./role-valid-scope.component.scss'],
  standalone : true,
  imports : [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ImportsModule,
    SkeletonModule,
    TablerIconComponent,
    SelectModule,
    
  ],providers:[
    provideTablerIcons({
      ...TablerIcons})
  ]
})
export class RoleValidScopeComponent implements OnInit, OnChanges {
  @Input('initScope') selectedScope: any[] = [];
  @Input('scopeEndPoint') scopeEndPoint: string = '';
  @Input('application') application: string = '';
  @Input('disabled') disabled: boolean = false;
  @Output('onScopeUpdate') onScopeUpdate = new EventEmitter<any>();
  @Output('roleLoading') roleLoading = new EventEmitter<any>();
  
  scopeTypes: any[] = [];
  scopeNames: {[key: string]: {[key: string]: any[]}} = {};
  loading: boolean = true;

  max: any;
  currentIndex!: number;
  // userMgmtApplicationId: string = '6d421cf8-5ed8-459b-a9b3-6236c57b7094';

  scopeForm = new FormGroup({
    validScopes: new FormArray([])
  })
  public destroy$ = new Subject<void>();
  operation!: string;
  operationTypes: typeof USER_MGMT_CNST.ROLE_MODULE_OPERATIONS  = USER_MGMT_CNST.ROLE_MODULE_OPERATIONS;
  constructor(
    private readonly httpSrv: HttpService,
    private readonly route: ActivatedRoute
  ) { }

  ngOnInit() {
    if(this.disabled) {
      this.scopeForm.disable();
    }
    
    this.validScopesArray.valueChanges.subscribe(data => {
      const areValid = data.reduce((a: any, e: any) => !a ? a : e.scopeType && e.scopeName,true);
      if(areValid?.length > 0) {
        // Flatten the scope records.
        let flattenedRecords: any[] = [];

        data.forEach((scope: any) => {
          if(typeof scope.scopeName === 'string') {
            flattenedRecords.push(this.buildScopeObj(scope.scopeType, scope.scopeName));
            return;
          }

          scope.scopeName.forEach((sn: any) => {
            flattenedRecords.push(this.buildScopeObj(scope.scopeType, sn));
          })
        })
        this.onScopeUpdate.emit(flattenedRecords);
      }else{
        this.onScopeUpdate.emit(data);
      }
    })
    this.subscribeRouterEvents();
  }
 
  getScopeTypes(index: number) {
    const selectedTypes = this.validScopesArray.controls
      .map((scope: any, i: number) => i !== index ? scope.get('scopeType')?.value : null)
      .filter((type: any) => type);

    return this.scopeTypes.filter(type => !selectedTypes.includes(type));
  }

  subscribeRouterEvents() {
    this.route.queryParams
      ?.pipe(takeUntil(this.destroy$))
      ?.subscribe((params: any) => {
        this.operation = params['operation'];
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // If application changes
    this.validScopesArray.clear();
    this.getScopeTypesInApplication();

    // If scope updated
    if(changes['selectedScope']) {
      this.validScopesArray.clear();

      // Group by scopeType
      const currentScope = changes['selectedScope'].currentValue || [];
      const scopeNamesGroupByType: any = {};

      currentScope.forEach((s: any) => {
        // Fetch the existing scope names in that type
        // if not there insert new key with scope type
        scopeNamesGroupByType[s.scopeType] = scopeNamesGroupByType[s.scopeType] || [];

        // Push the current scope name into the array.
        scopeNamesGroupByType[s.scopeType].push(s.scopeName);
      });

      Object.keys(scopeNamesGroupByType).forEach(st => {
        let scopeObj = {
          scopeType: st,
          scopeName: scopeNamesGroupByType[st]
        }
        this.addNewScope(scopeObj);
      })
    }
  }

  updateMax() {
    this.max = this.scopeTypes?.length;
  }
removeScopeName(rowIndex: number, chipIndex: number, selectedItems: any[]): void {
  const updated = selectedItems.filter((_, idx) => idx !== chipIndex);
  this.scopeForm
    ?.get('validScopes')
    ?.get(rowIndex.toString())
    ?.get('scopeName')
    ?.setValue(updated);
  this.updateTouchForScopeType(rowIndex);
}
  getScopeTypesInApplication() {
    this.scopeTypes = [];
    this.updateMax();

    if(!this.scopeEndPoint) {
      console.error("Scope end point is missing for application: " + this.application);
      return;
    }
    this.loading = true; // Start loading
    this.roleLoading.emit(true);
    this.httpSrv.makeGetApiCall("GET_SCOPE_TYPES", this.scopeEndPoint).subscribe({
      next: (res: any) => {
      this.scopeTypes = res;
        this.updateMax();
        const types: any = {};
        this.selectedScope.forEach(s => types[s.scopeType] = true);

        // Load options for all the types that are already selected.
        this.scopeTypes.forEach(type => this.getScopeNamesUnderTypes(type));
      },
      complete: () => {
        this.loading = false; // Start loading
        this.roleLoading.emit(false);
      },
      error: (err: any) => {
        console.log("err:: ", err);
        this.loading = false; 
        this.roleLoading.emit(false);
      }
    });
  }

  updateTouchForScopeType(i: number): void {
    const scopeNameControl = this.scopeForm?.get('validScopes')?.get(i.toString())?.get('scopeName');
    if (scopeNameControl) {
      scopeNameControl.markAsTouched();
      scopeNameControl.updateValueAndValidity();
    }
  }

  getScopeNamesUnderTypes(type: string) {
    if(!this.scopeNames[this.application]) {
      this.httpSrv.makeGetApiCall('GET_SCOPE_NAMES_UNDER_TYPE', this.scopeEndPoint, {replaceParams: {REPLACE_SCOPE_TYPE: type}}).subscribe({
        next: (res: any) => {
          const scopeNames = res.response || [];
          this.scopeNames = this.scopeNames || {};
          this.scopeNames[this.application] = this.scopeNames[this.application] || {};
          this.scopeNames[this.application][type] = scopeNames;
        },
        complete: () => {},
        error: (err: any) => {
          console.log("err:: ", err);
        }
      });
    }
  }

  getScopeTypeFromValidScopesArray(index: number) {
    return this.validScopesArray?.controls?.[index]?.get('scopeType')?.value ?? null;
  }

  getScopeNamesForType(index: number) {
    this.currentIndex = index;
    const type = this.getScopeTypeFromValidScopesArray(index);
    if(!type || !this.scopeNames[this.application]) return [];
    return this.scopeNames[this.application][type] || [];
  }

  get validScopesArray(): FormArray {
    return this.scopeForm.get('validScopes') as FormArray
  }

  get selectedScopeTypes(): string[] {
    const currentScope = this.validScopesArray.value;
    return currentScope.map((s: any) => s.scopeType);
  }

  getScopeType(index: number) {
    const scopeInfo = this.validScopesArray.value[index];
    return scopeInfo ? scopeInfo.scopeType : null;
  }

  buildScopeId(st: string, sn: string) {
    return st + "##" + sn;
  }

  buildScopeObj(st: string, sn: string) {
    return {
      scopeType: st,
      scopeName: sn
    }
  }

  newScope(value: any): FormGroup {
    value = value || {};
    return new FormGroup({
      scopeType: new FormControl(value.scopeType || '', [Validators.required]),
      scopeName: new FormControl(value.scopeName || '', [Validators.required])
    });
  }

  addNewScope(value: any = {scopeType: '', scopeName: ''}) {
    let isValidScopes = this.validScopesArray.controls.reduce((a, e) => !a ? a : e.valid, true);
    if(!isValidScopes || (this.max && this.validScopesArray?.length >= this.max)) {
      console.log("Existing form is empty or limit exceeded");
      return;
    }
    this.validScopesArray.push(this.newScope(value));
    this.subscribeToScopeTypeChanges()
  }

  subscribeToScopeTypeChanges() {
    const validScopesArray = this.scopeForm.get('validScopes') as FormArray;
    validScopesArray.controls.forEach((control, index: number) => {
      const group = control as FormGroup;
      const scopeTypeControl = group.get('scopeType');

      if (scopeTypeControl) {
        scopeTypeControl.valueChanges.subscribe((newValue) => {
          console.log(`Scope Type changed at index ${index}:`, newValue);
          this.resetScopeSelection()
        });
      }
    });
  }

  resetScopeSelection() {
    const scopeFormArray = this.scopeForm.get('validScopes') as FormArray;
    if(this.currentIndex) {
      const scopeControl = scopeFormArray.at(this.currentIndex).get('scopeName');
      if (scopeControl) {
        scopeControl.setValue([]);
      }
    }
  }

  removeScope(index: number) {
    this.validScopesArray.removeAt(index);
  }

  onScopeTypeChange(index: number){
    this.validScopesArray.controls[index].get('scopeName')?.setValue('');
  }

  getSelectedOptions(): string[] {
    return this.validScopesArray.controls
      .map((control: any) => control.get('scopeType')?.value)
      .filter((value: string) => value);
  }
  
  isOptionDisabled(option: string, index: number): boolean {
    const selectedOptions = this.getSelectedOptions();
    return selectedOptions.includes(option) && selectedOptions[index] !== option;
  }

  generateType(validScopesArray:any,max: any) :any{
    return validScopesArray?.length ? validScopesArray.length >= max : false;
  }

  /**
  * Lifecycle hook - Unsubscribes from observables when the component is destroyed
  */
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
